var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.isDefaultTenant)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"content"},[_c('custom-logo',{attrs:{"tenant":_vm.tenant}})],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }